<template>
  <div>
    <div class="notification is-warning is-marginless">
      <p class="is-uppercase is-size-7">
        <span>La gestion de l’affichage des documents se fait à partir de  <a
          @click="goToProgram"
          class="is-underline">la fiche programme </a> en choisissant l’affectation « espace acquéreur » pour chaque fichier. Ci-dessous, la liste des documents visibles par tous les acquéreurs du programme :</span>
      </p>
    </div>
    <div class="is-padding">
      <div
        v-if="documents.length"
        class="is-border">
        <template v-for="(document, i) in documents">
          <div
            class="is-padding-small"
            :key="document.fus_id"
            :class="{'is-border-top': i>=1}">
            <span class="is-padding-right">
              <i class="fal fa-file-pdf"></i>
            </span>
            <a @click="openPreview(document)">
              {{ document.filename }}
            </a>
          </div>
        </template>
      </div>
      <div
        class=""
        v-else>
        <b>
          Aucun document disponible
        </b>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BuyerSpaceDocs',
  props: {
    program: {
      type: Object
    },
    timeline: {
      type: Array
    }
  },
  computed: {
    documents () {
      if (this.program.documents.length) {
        return this.program.documents.filter(x => {
          return x.destination && x.destination.length && x.destination.includes('buyer_space')
        })
      } else {
        return []
      }
    }
  },
  methods: {
    goToProgram () {
      this.$router.push({ name: 'ProgramEdit', params: { id: this.program.pk }, query: { panel: 'DOCS' } })
    },
    /**
      * open preview document
      * @param {object} selectedDocument
      */
    openPreview (selectedDocument) {
      let params = {
        link: selectedDocument.path
      }
      this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_SAAS', params })
    }
  }
}
</script>
